import { Controller } from "@hotwired/stimulus"

// Loads a turbo frame in a modal with current form state as URL parameters
// Usage:
//   1. Wrap form + modal in: <div data-controller="form-modal">
//   2. Add to form: data: { form_modal_target: 'form' }
//   3. Add to turbo_frame: data: { form_modal_target: 'frame', url: 'your_path' }
//   4. Add to button: data: { action: 'click->form-modal#load' }
//
//   See "View Metrics" on /tasks/quality-control-tasks for an implementation example.
export default class extends Controller {
  static targets = ["frame", "form"]

  load(event) {
    const formData = new FormData(this.formTarget)
    const params = new URLSearchParams(formData)

    const baseUrl = this.frameTarget.dataset.url
    this.frameTarget.src = `${baseUrl}?${params.toString()}`
    this.frameTarget.reload()
  }
}
